export default "__VITE_ASSET__DCuarOrk__"